import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import DialogAction from '@ricoh/ria.client.core/components/dialog/action';
import Counter from '@ricoh/ria.client.core/components/indicator/counter';

import type { DialogSessionProps, DialogSessionRef } from './_.type';

import useDialogSessionHooks from './_.hook';

/** DialogSession. */
export default memo(
  forwardRef(function DialogSession(props: DialogSessionProps, ref: ForwardedRef<DialogSessionRef>): ReactNode {
    const { t } = useTranslation();

    const { refs, states, events } = useDialogSessionHooks(props, ref);

    return (
      <DialogAction
        title={t('session.title')}
        state={states.showState}
        actionButtons={[
          {
            buttonProps: {
              themeColor: 'error',
              children: t('no'),
              onClick: events.onClickRevoke,
            },
          },
          {
            primary: true,
            buttonProps: {
              themeColor: 'primary',
              children: t('yes'),
              onClick: events.onClickExtend,
            },
          },
        ]}
      >
        <Counter
          ref={refs.counterRef}
          render={states.renderCounter}
        />
      </DialogAction>
    );
  }),
);
